export interface DemoStep {
  id: string;
  label: string;
  hint: string;
}

export const DEMO_STEPS: DemoStep[] = [
  { id: "palm", label: "OPEN PALM", hint: "Open your hand to awaken the universe" },
  { id: "orbit", label: "MOVE HAND", hint: "Move one hand to orbit the cosmos" },
  { id: "pinch", label: "PINCH", hint: "Pinch to compress gravity" },
  { id: "fist", label: "FIST", hint: "Close a fist for a supernova" },
  { id: "apart", label: "TWO HANDS APART", hint: "Move both hands apart to expand" },
  { id: "together", label: "TWO HANDS TOGETHER", hint: "Hold hands together to form a black hole" },
  { id: "swipe", label: "SWIPE", hint: "Swipe to change formation" },
];

export class DemoSequence {
  private index = 0;
  private active = false;
  private duration = 15;
  private startedAt = 0;

  start(seconds: 15 | 30): void {
    this.active = true;
    this.duration = seconds;
    this.index = 0;
    this.startedAt = performance.now();
  }

  stop(): void {
    this.active = false;
  }

  isActive(): boolean {
    return this.active;
  }

  current(): DemoStep | null {
    if (!this.active) return null;
    const elapsed = (performance.now() - this.startedAt) / 1000;
    if (elapsed >= this.duration) {
      this.active = false;
      return null;
    }
    const slot = this.duration / DEMO_STEPS.length;
    this.index = Math.min(DEMO_STEPS.length - 1, Math.floor(elapsed / slot));
    return DEMO_STEPS[this.index] ?? null;
  }
}
